// "Itinerary" card of a charter request: route and departure.
import { Card, Descriptions } from 'antd';

import type { CharterRequestDetail } from '../../api/types';
import { airportLabel } from '../../data/airportLabel';
import { withAbbr } from '../../data/airportTime';

export function ItineraryCard({
  r,
}: {
  r: CharterRequestDetail;
}) {
  return (
    <Card title="Itinerary">
      <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
        {/* SHAR-584/585 — ICAO codes (the API resolves them), with city and
            country, matching how routes read everywhere else in the product. */}
        <Descriptions.Item label="Route" span={2}>
          {airportLabel(r.originCode, r.originCity, r.originCountry)} → {airportLabel(r.destCode, r.destCity, r.destCountry)}
        </Descriptions.Item>
        <Descriptions.Item label="Departure">{withAbbr(`${r.departureDate} ${r.departureTime}`, r.departureZoned)}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
